import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Spin } from "antd";
import { Table, Alert, Row, Col, Button, Spinner, Dropdown, ButtonGroup } from "react-bootstrap";
// import { Modal, ModalHeader, ModalFooter, ModalBody } from "reactstrap";
import { Link } from "react-router-dom";
import axios from 'axios';
import Loader from "./../../../utilityComponents/MiniLoader";
import {
    fetchTopologyData,
    performAllPreValidation,
    startExecution,
    stopExecution,
    downloadTopologySchemaFile,
} from "./../../../actions/closeLoop/topology/index";

import PaginationBar from "./Pagination/Pagination";
import FileUpload from "./upload/FileUpload";
import StartExecutionConfirmationModal from "./startExecution/StartExecutionModal";
import DeleteTopologyDataModel from "./deleteTopology/DeleteTopologyModel";
import { downloadCADTopology, downloadReportFiles } from "../../UserFunctions";
import PropTypes from "prop-types";
import Styles from '../scenarioFileUpload/uploadItem/uploadItem.module.css';
import StylesU from '../scenarioFileUpload/uploadProgress/uploadProgress.module.css';
function Topology(props) {
    const [startExecutionModal, setStartExecutionModal] = useState(false);
    const [selectedTopology, setSelectedTopology] = useState("");
    const [deleteJobUuid, setdeleteJobUuid] = useState(0);
    const [deleteSelectedRow, setDeleteSelectedRow] = useState(undefined);
    const [downloadErrorMessage, setDownloadErrorMessage] = useState(undefined);
    const [onDownloadProgress, setDownloadProgress] = useState(0);
    const [downloadProgressFlag, setDownloadProgressFlag] = useState(false);
    const loadingTip = 'Downloading...';
    useEffect(() => {
        props.getTopologyData();
    }, []);

    const closeStartExecutionModal = () => {
        setStartExecutionModal(false);
    };

   const downloadLogFilesCad = (destination_url, payload) => {
    return axios
        .post(destination_url, payload, { responseType: "blob",
              onDownloadProgress(progressEvent) {
                 let progress = Math.round((progressEvent.loaded / progressEvent.total) * 100);
                 setDownloadProgress(progress)
                 setDownloadProgressFlag(true)

            }}
          )

        .then((response) => {
            return response;
        })
        .catch((error) => {
            let message = ""
            if(error.response.status == 400){
                message = "The execution is not started or stopped the execution manually"
            }else{
                message = "Error in downloading log file"
            }
            // if (
            //     error.hasOwnProperty("response") &&
            //     error.response.hasOwnProperty("data") &&
            //     error.response.data.hasOwnProperty("message")
            // ) {
            if (
                Object.prototype.hasOwnProperty.call(error, "response") &&
                Object.prototype.hasOwnProperty.call(error.response, "data") &&
                Object.prototype.hasOwnProperty.call(error.response.data, "message")
            ) {
                return Promise.reject(error);
            } else {
                return Promise.reject({
                    response: {
                        data: {
                            message: message,
                        },
                    },
                });
            }
        });
    };
   const downloadReportFilesCad = (destination_url, payload) => {
    return axios
       .post(destination_url, payload, { responseType: "blob",
              onDownloadProgress(progressEvent) {
                 let progress = Math.round((progressEvent.loaded / progressEvent.total) * 100);
                 setDownloadProgress(progress)
                 setDownloadProgressFlag(true)
//                 dispatch({type: SET_DOWNLOAD_TOPOLOGY_SCHEMA_FILE_REQUEST, payload});

            }}
        )
        .catch((error) => {
            // if (
            //     error.hasOwnProperty("response") &&
            //     error.response.hasOwnProperty("data") &&
            //     error.response.data.hasOwnProperty("message")
            // ) {
            if (
                Object.prototype.hasOwnProperty.call(error, "response") &&
                Object.prototype.hasOwnProperty.call(error.response, "data") &&
                Object.prototype.hasOwnProperty.call(error.response.data, "message")
            ) {
                return Promise.reject(error);
            } else {
                return Promise.reject({
                    response: {
                        data: {
                            message: "Error in downloading report file",
                        },
                    },
                });
            }
        });
    };
  const downloadCADTopologyFile = (destination_url, payload) => {
    return axios
        .post(destination_url, payload, { responseType: "json",
              onDownloadProgress(progressEvent) {
                 let progress = Math.round((progressEvent.loaded / progressEvent.total) * 100);
                 setDownloadProgress(progress)
                 setDownloadProgressFlag(true)

            }}
        )
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
            // if (
            //     error.hasOwnProperty("response") &&
            //     error.response.hasOwnProperty("data") &&
            //     error.response.data.hasOwnProperty("message")
            // ) {
            if (
                Object.prototype.hasOwnProperty.call(error, "response") &&
                Object.prototype.hasOwnProperty.call(error.response, "data") &&
                Object.prototype.hasOwnProperty.call(error.response.data, "message")
            ) {
                return Promise.reject(error);
            } else {
                return Promise.reject({
                    response: {
                        data: {
                            message: "Error in downloading cad topology file",
                        },
                    },
                });
            }
        });
    };
    const handleStartExecution = (e) => {
        const stage = e.target.innerHTML;
        const payload = {
            topologyId: e.target.value,
        };
        if (stage === "Validate") {
            props.doPreValidationChecks(payload);
        } else if(stage === "Stop"){
            handleStopExecution(e)
        }else {
            console.log("Stage", stage);
            setSelectedTopology(payload.topologyId);
            setStartExecutionModal(true);
            //            const specificTopology = props.items.find((item) => item['job_id'] === payload['topologyId']);
            //            const data = {
            //                ...payload,
            //                data: Object.assign({}, ...specificTopology['validate']['config'])
            //            };

            //            props.initiateExecution(data);
        }
    };

    const handleStopExecution=(e)=>{
       const payload = {
            topologyId: e.target.value,
       };
       props.stopTopology(payload)
    }

    const handleDelete = (e, index_val) => {
        e.preventDefault();
        const index = index_val.index;
        const job_uuid_del = props.items[index]["job_id"];
        setdeleteJobUuid(job_uuid_del);
        console.log("Job UUID : ", deleteJobUuid);
        setDeleteSelectedRow(index);
        console.log("dbdata in cadtopo:", props.items);
    };

    const handleCloseDeleteModal = () => {
        setDeleteSelectedRow(undefined);
    };

    const handleDownload = (index_val) => {
        let job_id = props.items[index_val.index]["job_id"];
        const payload = {
            cad_topology_job_uuid: job_id,
        };
        setDownloadProgressFlag(true)
        downloadCADTopologyFile("/cad_topology_download", payload)
            .then((response) => {
                if (response && response.status === 200) {
                    const fileName = "CAD_topology_" + job_id + ".json";
                    const json = JSON.stringify(response.data, null, 2);
                    const url = window.URL.createObjectURL(
                        new Blob([json], { type: "application/json" })
                    );
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute("download", fileName);
                    document.body.appendChild(link);
                    link.click();
                    console.log(response.data);
                    setDownloadProgressFlag(false)
                    setDownloadProgress(0)
                } else {
                    console.log("Execption Occurred");
                }
            })
            .catch((error) => {
                console.log("catch error", error);
                setDownloadProgressFlag(false)
                setDownloadProgress(0)
                // if(error.hasOwnProperty("response") && error.response.hasOwnProperty("data")
                //    && error.response.data.hasOwnProperty("message")){
                if (
                    Object.prototype.hasOwnProperty.call(error, "response") &&
                    Object.prototype.hasOwnProperty.call(error.response, "data") &&
                    Object.prototype.hasOwnProperty.call(error.response.data, "message")
                ) {
                   let message = error.response.data.message
                   setDownloadErrorMessage(message);
                } else {
                   setDownloadErrorMessage("Something Went Wrong, Please Try Again!!");
                }
            });
    };

    const handleReportDownload = (index_val) => {
        let job_id = props.items[index_val.index]["job_id"];
        const payload = {
            cad_topology_job_uuid: job_id,
        };
        setDownloadProgressFlag(true)
        downloadReportFilesCad("/fetch_report", payload)
            .then((response) => {
                if (response && response.status === 200) {
                    // const fileName = response.headers["content-disposition"].split("filename=")[1];
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute(
                        "download",
                        response.headers["content-disposition"].split("filename=")[1]
                    );
                    document.body.appendChild(link);
                    link.click();
                    setDownloadProgressFlag(false)
                    setDownloadProgress(0)
                } else {
                    console.log("Execption Occurred");
                }
            })
            .catch((error) => {
                console.log("catch error", error);
                setDownloadProgressFlag(false)
                setDownloadProgress(0)
                // if (
                //     error.hasOwnProperty("response") &&
                //     error.response.hasOwnProperty("data") &&
                //     error.response.data.hasOwnProperty("message")
                // ) {
                if (
                    Object.prototype.hasOwnProperty.call(error, "response") &&
                    Object.prototype.hasOwnProperty.call(error.response, "data") &&
                    Object.prototype.hasOwnProperty.call(error.response.data, "message")
                ) {
                    setDownloadErrorMessage(error.response.data.message);
                } else {
                    setDownloadErrorMessage("Something Went Wrong, Please Try Again!!");
                }
            });
    };

    const handleLogsDownload = (index_val) => {
        let job_id = props.items[index_val.index]["job_id"];
        const payload = {
            cad_topology_uuid: job_id,
        };
        setDownloadProgressFlag(true)
        downloadLogFilesCad("/log_files/download", payload)
            .then((response) => {
                if (response && response.status === 200) {
                    // const fileName = response.headers["content-disposition"].split("filename=")[1];
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute(
                        "download",
                        response.headers["content-disposition"].split("filename=")[1]
                    );
                    document.body.appendChild(link);
                    link.click();
                    setDownloadProgressFlag(false)
                    setDownloadProgress(0);
                } else {
                    console.log("Execption Occurred");
                }
            })
            .catch((error) => {
                setDownloadProgressFlag(false)
                setDownloadProgress(0);
                console.log("catch error", error);
                // if (
                //     error.hasOwnProperty("response") &&
                //     error.response.hasOwnProperty("data") &&
                //     error.response.data.hasOwnProperty("message")
                // ) {
                if (
                    Object.prototype.hasOwnProperty.call(error, "response") &&
                    Object.prototype.hasOwnProperty.call(error.response, "data") &&
                    Object.prototype.hasOwnProperty.call(error.response.data, "message")
                ) {
                    setDownloadErrorMessage(error.response.data.message);
                } else {
                    setDownloadErrorMessage("Something Went Wrong, Please Try Again!!");
                }
            });
    };

    const startDownloadTopology = (index) => {
        const payload = {
            topology_uuid: props.items[index['index']]['job_id']
        };
        props.downloadTopology(payload);
    }
//    let progressBarRender = null
//    console.log(downloadProgressFlag)
//    if(downloadProgressFlag){
//        let text = "Downloading"
//        if(onDownloadProgress == 100){
//            text = "Downloaded"
//        }
//         progressBarRender =
//                        <div className={StylesU.wrapper} id="progressBar">
//                            <h4>Downloading</h4>
//                            <div className={Styles.wrapperItem}>
//                                <div className={Styles.leftSide}>
//                                    <div className={Styles.progressBar}>
//                                        <div style={{ width: `${onDownloadProgress}%`}}/>
//                                    </div>
//                                    <label>{text}</label>
//                                </div>
//                                    <span className={Styles.percentage}>{onDownloadProgress}%</span>
//                            </div>
//                        </div>
//    }
//    console.log(progressBarRender, "render")
    return (
        <>
            <Spin spinning={downloadProgressFlag} tip={loadingTip}>
                <Row>
                    <Col md={12} ls={12}>
                        <FileUpload />
                    </Col>
                </Row>
                {props.message ? <Alert variant="info">{props.message}</Alert> : undefined}
                {props.validationError ? (
                    <Alert variant="danger">
                        <Alert.Heading>Pre-Validation of Configuration Failed!</Alert.Heading>
                        <hr />
                        <p>{props.validationError}</p>
                        <p>Please clear the above error to proceed with the Execution.</p>
                    </Alert>
                ) : undefined}
                {downloadErrorMessage ? (
                    <Alert variant="danger">{downloadErrorMessage}</Alert>
                ) : undefined}
                { ( props.loading || props.downloadTopologyLoading ) ? (
                    <Loader />
                ) : ( props.error || props.downloadTopologyError ) ? (
                    <Alert key="danger" variant="danger">
                        { props.error || props.downloadTopologyError }
                    </Alert>
                ) : props.items.length === 0 ? (
                    <Alert key="info" variant="info">
                        No records found for this page !
                    </Alert>
                ) : (
                    <>
                        <div className="card-body">
                            <Row>
                                <Col md={12} lg={12}>
                                    <div style={{ overflowX: "auto", whiteSpace: "nowrap" }}>
                                        <Table
                                            striped
                                            bordered
                                            hover
                                            size="md"
                                            style={{ width: "auto", minWidth: "100%" }}
                                        >
                                            <thead>
                                                <tr>
                                                    <th>#</th>
                                                    <th>Topology Tag Name</th>
                                                    <th>Description</th>
                                                    <th>Start Date</th>
                                                    <th>End Date</th>
                                                    <th>Validation & Execution</th>
                                                    <th>Actions</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {props.items.map((item, index) => {
                                                    return (
                                                        <tr key={index}>
                                                            <td>{index}</td>
                                                            {/* <td>{ item['job_id'] }</td> */}
                                                            <td>{item["topology_tag_name"]}</td>
                                                            <Link
                                                                to={{
                                                                    pathname:
                                                                        "/close_loop/pre-validation/configuration",
                                                                    state: {
                                                                        cadTopologyId: item["job_id"],
                                                                    },
                                                                }}
                                                                style={{ textDecoration: "none" }}
                                                            >
                                                                <td style={{ border: "0px" }}>
                                                                    {item["description"]}
                                                                </td>
                                                            </Link>
                                                            <td>{item["start_date"]}</td>
                                                            <td>{item["end_date"]}</td>
                                                            <td>
                                                                <Button
                                                                    style={{backgroundColor: "#757AF7"}}
                                                                    variant="primary"
                                                                    className={
                                                                        item["validate"] &&
                                                                        item["validate"]["loading"]
                                                                            ? "disabled"
                                                                            : ""
                                                                    }
                                                                    onClick={(e) => {
                                                                        handleStartExecution(e);
                                                                    }}
                                                                    value={item["job_id"]}
                                                                >
                                                                    {item["validate"] &&
                                                                    item["validate"]["loading"] ? (
                                                                        <>
                                                                            <Spinner
                                                                                as="span"
                                                                                animation="grow"
                                                                                size="sm"
                                                                                role="status"
                                                                                aria-hidden="true"
                                                                            />
                                                                            {item["execution"]
                                                                                .replaceAll("e", "")
                                                                                .concat("ing..")}
                                                                        </>
                                                                    ) : (
                                                                        item["execution"]
                                                                    )}
                                                                </Button>
                                                            </td>
                                                            <td>
                                                                <Button
                                                                    variant="primary"
                                                                    className="btn"
                                                                    onClick={(e) =>
                                                                        handleDelete(e, { index })
                                                                    }
                                                                    value="Delete"
                                                                    style={{ margin: "1px", backgroundColor: "#757AF7" }}
                                                                >
                                                                    <i className="fas fa-trash"></i>
                                                                </Button>
                                                                <ButtonGroup style={{ margin: "1px" }}>
                                                                    <Dropdown>
                                                                        <Dropdown.Toggle id="dropdown-basic" style={{backgroundColor: "#757AF7"}}>
                                                                            <i className="fas fa-download"></i>
                                                                        </Dropdown.Toggle>
                                                                        <Dropdown.Menu>
                                                                            <Dropdown.Item
                                                                                onClick={() =>
                                                                                    handleDownload({
                                                                                        index,
                                                                                    })
                                                                                }
                                                                            >
                                                                                CAD Topology JSON
                                                                            </Dropdown.Item>
                                                                            <Dropdown.Divider />
                                                                            <Dropdown.Item
                                                                                onClick={() =>
                                                                                    handleReportDownload(
                                                                                        { index }
                                                                                    )
                                                                                }
                                                                            >
                                                                                Download Report Files
                                                                            </Dropdown.Item>
                                                                            <Dropdown.Divider />
                                                                            <Dropdown.Item
                                                                                onClick={() =>
                                                                                    handleLogsDownload({
                                                                                        index,
                                                                                    })
                                                                                }
                                                                            >
                                                                                Download Log Files
                                                                            </Dropdown.Item>
                                                                        </Dropdown.Menu>
                                                                    </Dropdown>
                                                                </ButtonGroup>
                                                            </td>
                                                        </tr>
                                                    );
                                                })}
                                            </tbody>
                                        </Table>
                                    </div>
                                </Col>
                            </Row>
                            <Row style={{ paddingTop: "1%" }}>
                                <Col md={12} lg={12}>
                                    <PaginationBar />
                                </Col>
                            </Row>
                            {startExecutionModal ? (
                                <StartExecutionConfirmationModal
                                    topologyId={selectedTopology}
                                    show={startExecutionModal}
                                    closeModal={closeStartExecutionModal}
                                />
                            ) : undefined}
                            {deleteSelectedRow >= 0 ? (
                                <DeleteTopologyDataModel
                                    deleteSelectedRow={deleteSelectedRow.toString()}
                                    handleCloseDeleteModal={handleCloseDeleteModal}
                                    deleteJobUuid={deleteJobUuid.toString()}
                                    useHistory={props}
                                />
                            ) : undefined}
                        </div>
                    </>
                )}
             </Spin>
        </>
    );
}

const mapStateToProps = (state) => ({
    loading: state.topology.loading,
    downloadTopologyLoading: state.downloadTopologySchema.loading,
    downloadTopologyError: state.downloadTopologySchema.error,
    error: state.topology.error,
    items: state.topology.items,
    validationError: state.topology.validationError,
    message: state.topology.message,
});

const mapDispatchToProps = (dispatch) => ({
    getTopologyData: () => dispatch(fetchTopologyData()),
    doPreValidationChecks: (payload) => dispatch(performAllPreValidation(payload)),
    initiateExecution: (payload) => dispatch(startExecution(payload)),
    downloadTopology: (payload) => dispatch(downloadTopologySchemaFile(payload)),
    stopTopology: (payload) => dispatch(stopExecution(payload)),
});

Topology.propTypes = {
    getTopologyData: PropTypes.func,
    doPreValidationChecks: PropTypes.func,
    items: PropTypes.array,
    message: PropTypes.string,
    validationError: PropTypes.string,
    loading: PropTypes.bool,
    error: PropTypes.string,
};

export default connect(mapStateToProps, mapDispatchToProps)(Topology);
